
import MensualConsumptionWidgetTest from './MensualConsumptionWidgetTest';

export default MensualConsumptionWidgetTest
